import { base64UrlEncode } from '@app/utils/url'

import { getBacktrack } from './getBacktrack'

export const getSourceUrlQueryParam = () => {
  const backUrl = getBacktrack()
  if (!backUrl) {
    return ''
  }
  const url = new URL(backUrl)
  return `&sourceUrl=${base64UrlEncode(encodeURIComponent(url.pathname + url.search))}`
}
